import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { StringUtils } from '@shared/helpers/StringUtils';
import { AlergiaDto, AlergiaServiceProxy, PacienteAlergiaServiceProxy, UpdatePacienteAlergiaDto } from '@shared/service-proxies/service-proxies';
import { TipoAlergiaList } from '@shared/model/tipo-alergia-enum.model';

@Component({
  selector: 'app-edit-paciente-alergia',
  templateUrl: './edit-paciente-alergia.component.html',
  styleUrls: ['./edit-paciente-alergia.component.scss'],

})
export class EditPacienteAlergiaComponent extends AppComponentBase {

  public pacienteAlergia: UpdatePacienteAlergiaDto = new UpdatePacienteAlergiaDto();
  protected alergias: AlergiaDto[] = []
  protected saving: boolean = false;
  protected tiposAlergias: TipoAlergiaList = new TipoAlergiaList();
  protected showList: boolean = false;

  @Output() onSave = new EventEmitter<any>()

  constructor(
    injector: Injector,
    private readonly _alergiaService: AlergiaServiceProxy,
    private readonly _pacienteAlergiaService: PacienteAlergiaServiceProxy,
    public modalService: BsModalRef,
  ) {
    super(injector)
  }

  protected save(): void {
    if (!this.isFormValided()) return;
    abp.ui.setBusy();
    this.saving = true;
    this._pacienteAlergiaService.update(this.pacienteAlergia).pipe(
      finalize(() => {
        this.saving = false;
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.modalService.hide();
    })
  }

  protected getAlergias(): void {
    this.showList = true
    this._alergiaService.getAlergias(this.pacienteAlergia.substancia).subscribe((result) => {
      this.alergias = result;
    });
  }

  protected selectAlergia(alergia: AlergiaDto): void {
    this.pacienteAlergia.substancia = alergia.substancia;
    this.pacienteAlergia.tipoAlergia = alergia.tipoAlergia;
    this.showList = false;
  }


  private isFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.pacienteAlergia.substancia), message: "Informe a alergia.." },
      { condition: StringUtils.isNullOrEmpty(this.pacienteAlergia.tipoAlergia), message: "Informe o tipo alergia.." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
